import {
  ODataHeader,
  ODataString,
  ODataDecimal,
  ODataDate,
} from "pbas-vue-components";

import { translate2 } from "../trans2";
import { translate3 } from "../trans3";

const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
});
const storeHeaders = [
  new ODataHeader({
    type: new ODataString("Store/Id"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  // new ODataHeader({
  //   type: new ODataString("Store/Name"),
  //   visible: false,
  //   allowVisibilityChange: false,
  //   searchable: false,
  // }),
  new ODataHeader({
    type: new ODataString("Store/TranslationEffectives[]/LanguageCode"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "globals.store",
    type: new ODataString("Store/TranslationEffectives[]/Name", {
      getString: (item) => translate3(item.Store, "Name"),
    }),
    sortable: false,
    visible: true,
    searchable: true,
  }),
];

const headers1 = [
  new ODataHeader({
    title: "Id",
    type: new ODataString("Id"),
    visible: false,
    searchable: false,
    isIdentifier: true,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    type: new ODataString("MemberId"),
    visible: false,
    searchable: false,
    isIdentifier: true,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    title: "globals.member",
    type: new ODataString("MemberCertificate", {
      getHtml: (item) => {
        return `<a id="${item.MemberId}">${
          item.MemberCertificate
        }</a>`;
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
];
const headers2 = [
  new ODataHeader({
    type: new ODataString("Term/Id"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    type: new ODataString("Term/FullName"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    type: new ODataString("Term/Translations[]/LanguageCode"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "globals.term",
    type: new ODataString("Term/Translations[]/FullName", {
      getString: (item) => translate2(item.Term, "FullName"),
    }),
    sortable: true,
    visible: true,
    searchable: true,
    orderByKey: "Term/FullName",
  }),
  new ODataHeader({
    title: "globals.start_date",
    type: new ODataDate("StartDate"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "globals.end_date",
    type: new ODataDate("EndDate"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "globals.amount",
    type: new ODataDecimal("Amount", {
      getString: (item) => {
        const value = item.Amount;
        if (value === null || value === undefined) {
          return "";
        }
        if (typeof value !== "number") {
          return value;
        }
        return formatter.format(value);
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  // new ODataHeader({
  //   title: "headers.contributions_history_hours_details.reported_contribution",
  //   type: new ODataDecimal("Balance", {
  //     getString: (item) => {
  //       const value = item.Balance;
  //       if (value === null || value === undefined) {
  //         return "";
  //       }
  //       if (typeof value !== "number") {
  //         return value;
  //       }
  //       return formatter.format(value);
  //     },
  //   }),
  //   sortable: true,
  //   visible: true,
  //   searchable: true,
  // }),
];

function getHeaders(hasLocations) {
  let h = [].concat(headers1);
  if (hasLocations) {
    h = h.concat(storeHeaders);
  }
  h = h.concat(headers2);

  console.log("!!!!!!!!!!!!!!!!!!!!", JSON.stringify(h));
  return h;
}

export default getHeaders;
